<template>
    <div style="overflow-y: auto;height: calc(100vh - 85px);background-color: #ffffff;">
        <el-divider content-position="left">物项信息</el-divider>
        <el-row>
            <el-col :span="14">
                <el-form ref="dualUseItemForm" :model="dualUseItemForm" size="mini" label-width="120px" class="demo-form-inline dualUseItemForm" :rules="dualUseItemFormRules">
                    <el-form-item label="物项名称" prop="goodsName">
                        <el-input clearable v-model="dualUseItemForm.goodsName"></el-input>
                    </el-form-item>
                    <el-form-item label="HS编码" prop="hsCode">
                        <el-input clearable v-model="dualUseItemForm.hsCode"></el-input>
                    </el-form-item>
                    <el-form-item label="物项描述" prop="text">
                        <el-input clearable v-model="dualUseItemForm.text" type="textarea" :rows="2"></el-input>
                    </el-form-item>
                    <el-form-item label="候选数">
                        <el-radio-group v-model="count">
                            <el-radio :label="3">3</el-radio>
                            <el-radio :label="5">5</el-radio>
                            <el-radio :label="10">10</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-row>
                        <el-button style="margin-left: 15px;" type="primary" size="mini" @click="getData">发起筛查</el-button>
                    </el-row>
                </el-form>
            </el-col>
            <el-col :span="10">
                <el-descriptions title="【填写示例】" :column="1">
                    <el-descriptions-item label="物项名称">磁性探针</el-descriptions-item>
                    <el-descriptions-item label="物项描述">制动部件上的踏板行程测量系统;成分含量:错钕26.5%铁65.41%硼0.94%镝0.08%0.07%3.01%铝0.4%</el-descriptions-item>
                    <el-descriptions-item label="HS编码">9031900090</el-descriptions-item>
                </el-descriptions>
            </el-col>
        </el-row>
        <span class="tip_text">以下所有内容为基于人工智能模型，从技术参数角度给出的建议，供指引您判断方向仅供参考。</span>
        <el-divider content-position="left">评估报告</el-divider>
        <el-descriptions title=" " :column="1">
            <el-descriptions-item label="1.判定结果">
                <span v-if="hit === true">
                    <el-tag type="danger">存在风险</el-tag>
                </span>
                <span v-else-if="hit === false">
                    <el-tag type="success">无风险</el-tag>
                </span>
            </el-descriptions-item>
            <el-descriptions-item label="2.分类结论">
                <span style="color: black;font-size: 16px; font-weight: 600;">
                    {{ reason }}
                </span>
            </el-descriptions-item>
            <el-descriptions-item label="3.可能相关的其他控制类别"></el-descriptions-item>
        </el-descriptions>
        <el-table 
            :data="dualUseItemTable" 
            style="width: 100%" 
            :header-cell-style="{'text-align':'center'}" 
            size="mini" 
            border 
            max-height="300px"
        >
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column property="goodsName" label="物项名称" width="140" align="center"></el-table-column>
            <el-table-column property="controlCode" label="监管代码" width="100" align="center"></el-table-column>
            <el-table-column property="reason" label="管控原因" align="left"></el-table-column>
            <el-table-column property="text" label="规则描述" align="left"></el-table-column>
            <el-table-column property="score" label="余弦距离" width="80" align="center"></el-table-column>
            <el-table-column property="dashVectorResult" label="数据相关性" width="140" align="center"></el-table-column>
        </el-table>
    </div>
</template>
<script> 
import clean from 'lodash-clean';
export default {
    name: 'dualUseItemClassification',
    data() {
        return {
            dualUseItemForm:{
                goodsName:"",
                hsCode:"",
                text:"", // 规则描述
            },
            count:3, //    候选数
            hit:'', // 判断结果
            dualUseItemTable:[],
            reason:'',
            dualUseItemFormRules:{
                goodsName:[
                    {required: true, message: '请输入物项名称', trigger: 'blur'}
                ],
                
                text:[
                    {required: true, message: '请输入物项描述', trigger: 'blur'}
                ]
            }
        }
    },
    computed: {
        
    },
    mounted() {
    },
    created() {

    },
    methods: {
        // 获取规则数据
        getData(){
             this.$refs.dualUseItemForm.validate(async valid => {
                if (!valid) return;
                const params = {...this.dualUseItemForm}
                this.$api.AiPushItemToAi(this.count, params).then(res =>{
                    this.reason = res.reason
                    this.dualUseItemTable = res.dualUseList
                    this.hit = res.hit
                })
            })
        },
    },

}
</script>
<style scoped lang="less">
.width_100{
    width: 100% !important;
}

// 表头样式
.dualUseItemForm {
    margin: 0px 10px !important;
}

// .dualUseItemForm .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
//     margin-bottom: 5px !important;
//     width:100% !important;
// }
/* 没有 scoped 直接写 */
.el-table,
.el-table__header tr,
.el-table__header th,
.el-table__body tr,
.el-table__body td {
  border-color: #969696 !important;
}
/* 有 scoped 情况 */
/deep/ .el-table,
/deep/ .el-table__header tr,
/deep/ .el-table__header th,
/deep/ .el-table__body tr,
/deep/ .el-table__body td {
  border-color: #969696 !important; /* 修改这里为你想要的颜色 */
}

/* 表头底部单独边框（可选微调） */
/deep/ .el-table__header th {
  border-bottom-color: #969696 !important;
}
/deep/ .el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
    padding-bottom: 5px;
}
/deep/ .el-descriptions__header{
   margin-bottom: 5px; 
}
/deep/ .el-descriptions-item__container{
    align-items: center !important;
}
.tip_text{
    padding: 10px 10px ;
    font-size: 14px;
}
</style>